var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "users-settings" },
    [
      _c("div", { staticClass: "container-search" }, [
        _c("div", { staticClass: "left" }, [
          _c("div", { staticClass: "seach-bar" }, [
            _c("div", { staticClass: "container-svg-serach" }, [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "21",
                    height: "21",
                    viewBox: "0 0 21 21",
                    fill: "none",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M17.0625 8.53125C17.0625 10.4139 16.4514 12.1529 15.4219 13.5639L20.6145 18.7605C21.1271 19.2732 21.1271 20.1059 20.6145 20.6186C20.1018 21.1312 19.2691 21.1312 18.7564 20.6186L13.5639 15.4219C12.1529 16.4555 10.4139 17.0625 8.53125 17.0625C3.81855 17.0625 0 13.2439 0 8.53125C0 3.81855 3.81855 0 8.53125 0C13.2439 0 17.0625 3.81855 17.0625 8.53125ZM8.53125 14.4375C9.30687 14.4375 10.0749 14.2847 10.7915 13.9879C11.5081 13.6911 12.1592 13.256 12.7076 12.7076C13.256 12.1592 13.6911 11.5081 13.9879 10.7915C14.2847 10.0749 14.4375 9.30687 14.4375 8.53125C14.4375 7.75563 14.2847 6.9876 13.9879 6.27103C13.6911 5.55445 13.256 4.90335 12.7076 4.3549C12.1592 3.80645 11.5081 3.3714 10.7915 3.07459C10.0749 2.77777 9.30687 2.625 8.53125 2.625C7.75563 2.625 6.98761 2.77777 6.27103 3.07459C5.55445 3.3714 4.90335 3.80645 4.3549 4.3549C3.80645 4.90335 3.3714 5.55445 3.07459 6.27103C2.77777 6.9876 2.625 7.75563 2.625 8.53125C2.625 9.30687 2.77777 10.0749 3.07459 10.7915C3.3714 11.5081 3.80645 12.1592 4.3549 12.7076C4.90335 13.256 5.55445 13.6911 6.27103 13.9879C6.98761 14.2847 7.75563 14.4375 8.53125 14.4375Z",
                      fill: "#AB6E93",
                    },
                  }),
                ]
              ),
            ]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.valueInputSearch,
                  expression: "valueInputSearch",
                },
              ],
              attrs: { placeholder: _vm.$t("dash.placeholder.search") },
              domProps: { value: _vm.valueInputSearch },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.valueInputSearch = $event.target.value
                },
              },
            }),
          ]),
        ]),
        _c("div", { staticClass: "right" }, [
          _vm.SelectUser.length > 0
            ? _c(
                "div",
                {
                  staticClass: "btn-outline-primary icon-l",
                  on: { click: _vm.removeUserSelected },
                },
                [
                  _c("i", { staticClass: "fa-regular fa-trash-can" }),
                  _c("span", [_vm._v(_vm._s(_vm.$t("dash.button.delete")))]),
                ]
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "btn-primary icon-l",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.startAddUser.apply(null, arguments)
                },
              },
            },
            [
              _c("i", { staticClass: "fa-solid fa-user-plus" }),
              _c("span", [
                _vm._v(_vm._s(_vm.$t("dash.settings.users.header.add_user"))),
              ]),
            ]
          ),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "container-list-user" },
        [
          _c("div", { staticClass: "legend" }, [
            _c(
              "div",
              [
                _c("Checkbox", {
                  attrs: {
                    id: "selectAllUser",
                    isChecked: _vm.SelectUser.length >= 1,
                    isLine:
                      _vm.SelectUser.length < _vm.users.length &&
                      _vm.SelectUser.length >= 1,
                    isDisable: _vm.users.length == 0,
                    add: _vm.addAllUser,
                    remove: _vm.removeAllUser,
                  },
                }),
                _c(
                  "p",
                  {
                    class: { active: _vm.sortBy == "email", sort: true },
                    on: {
                      click: function ($event) {
                        return _vm.setSortBy("email")
                      },
                    },
                  },
                  [
                    _vm._v(_vm._s(_vm.$t("dash.settings.users.legend.email"))),
                    _c("i", { staticClass: "fa-solid fa-caret-down" }),
                  ]
                ),
              ],
              1
            ),
            _c(
              "p",
              {
                class: {
                  lastname: true,
                  active: _vm.sortBy == "lastname",
                  sort: true,
                },
                on: {
                  click: function ($event) {
                    return _vm.setSortBy("lastname")
                  },
                },
              },
              [
                _vm._v(_vm._s(_vm.$t("dash.settings.users.legend.last_name"))),
                _c("i", { staticClass: "fa-solid fa-caret-down" }),
              ]
            ),
            _c(
              "p",
              {
                class: {
                  firstname: true,
                  active: _vm.sortBy == "firstname",
                  sort: true,
                },
                on: {
                  click: function ($event) {
                    return _vm.setSortBy("firstname")
                  },
                },
              },
              [
                _vm._v(_vm._s(_vm.$t("dash.settings.users.legend.first_name"))),
                _c("i", { staticClass: "fa-solid fa-caret-down" }),
              ]
            ),
            _c(
              "p",
              {
                class: { role: true, active: _vm.sortBy == "role", sort: true },
                on: {
                  click: function ($event) {
                    return _vm.setSortBy("role")
                  },
                },
              },
              [
                _vm._v(_vm._s(_vm.$t("dash.settings.users.legend.role"))),
                _c("i", { staticClass: "fa-solid fa-caret-down" }),
              ]
            ),
            _c("p", { staticClass: "page" }, [_vm._v("Pages")]),
          ]),
          _vm._l(_vm.getUsersBySort, function (user) {
            return _c(
              "div",
              { key: user.id, staticClass: "user" },
              [
                _c(
                  "div",
                  { staticClass: "user-name" },
                  [
                    _c("Checkbox", {
                      attrs: {
                        id: user.id,
                        isChecked: _vm.SelectUser.includes(user.id),
                        add: _vm.addSelectUser,
                        remove: _vm.removeSelectUser,
                      },
                    }),
                    _c("label", { attrs: { for: user.id } }, [
                      _c("p", [_vm._v(_vm._s(user.email))]),
                    ]),
                    !user.confirmed_at
                      ? _c("div", { staticClass: "badge-outline-r" }, [
                          _c("i", { staticClass: "fa-solid fa-paper-plane" }),
                          _vm._v(_vm._s(_vm.$t("dash.status.inqueue"))),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
                _c("p", { staticClass: "lastname color-grey" }, [
                  _vm._v(_vm._s(user.lastname)),
                ]),
                _c("p", { staticClass: "firstname color-grey" }, [
                  _vm._v(_vm._s(user.firstname)),
                ]),
                _c(
                  "p",
                  { staticClass: "role color-grey" },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          user.admin == true
                            ? _vm.$t("dash.settings.user.Administrator") + " "
                            : user.role && user.role.length > 0
                            ? ""
                            : _vm.$t("dash.settings.user.Editor") + " "
                        ) +
                        "\n                \n                "
                    ),
                    _vm._l(user.role, function (r) {
                      return [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("dash.settings.user." + r) + " ") +
                            "\n                "
                        ),
                      ]
                    }),
                    user.role && user.role.includes("Viewer")
                      ? _c(
                          "span",
                          {
                            staticClass: "copyLink",
                            on: {
                              click: function ($event) {
                                return _vm.getViewerLoginUrl(user.id)
                              },
                            },
                          },
                          [
                            _c(
                              "Tooltip",
                              { attrs: { text: "Copier le lien" } },
                              [_c("i", { staticClass: "fa-solid fa-link" })]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  2
                ),
                _c(
                  "div",
                  { staticClass: "listPages" },
                  [
                    _vm._l(
                      _vm.getInfoAvatars(user.pages_access).slice(0, 4),
                      function (page) {
                        return _c(
                          "div",
                          {
                            key: page.id,
                            staticClass: "containerAvatar",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.addPage(user.id)
                              },
                            },
                          },
                          [
                            _c("Avatar", {
                              attrs: {
                                toggleDisplayReseau: true,
                                typeNetwork: page.network,
                                urlPicture: page.avatar,
                              },
                            }),
                          ],
                          1
                        )
                      }
                    ),
                    _vm.getInfoAvatars(user.pages_access).length > 4
                      ? _c(
                          "div",
                          {
                            staticClass: "ect",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.addPage(user.id)
                              },
                            },
                          },
                          [_c("i", { staticClass: "fa-regular fa-ellipsis" })]
                        )
                      : _c(
                          "div",
                          {
                            staticClass: "plus",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.addPage(user.id)
                              },
                            },
                          },
                          [_c("i", { staticClass: "fa-solid fa-plus" })]
                        ),
                  ],
                  2
                ),
                _c(
                  "div",
                  {
                    staticClass: "btn-outline-primary icon-l",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.startEditUser(user.id)
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "fa-solid fa-pen" }),
                    _c("span", [_vm._v(_vm._s(_vm.$t("dash.button.edit")))]),
                  ]
                ),
                _c(
                  "ContextMenu",
                  {
                    attrs: {
                      options: _vm.getOptionsContextMenu(user.id),
                      id: user.id,
                    },
                    on: { clickOption: _vm.clickOptionContextMenu },
                  },
                  [_c("i", { staticClass: "fa-solid fa-ellipsis-vertical" })]
                ),
              ],
              1
            )
          }),
        ],
        2
      ),
      _vm.displayAddPopUpUser
        ? _c("AddUserPopup", {
            attrs: {
              display: _vm.displayAddPopUpUser,
              pages_access: _vm.pages_access,
              groups: _vm.groups,
              roles: _vm.infoUser.role,
              isAdmin: _vm.infoUser.admin,
              emailExist: _vm.emailExist,
            },
            on: { closePopUp: _vm.closeAddPopUpUser, submit: _vm.addUser },
          })
        : _vm._e(),
      _vm.displayEditPopUpUser
        ? _c("AddUserPopup", {
            attrs: {
              display: _vm.displayEditPopUpUser,
              pages_access: _vm.pages_access,
              groups: _vm.groups,
              roles: _vm.infoUser.role,
              isAdmin: _vm.infoUser.admin,
              emailExist: _vm.emailExist,
              data: _vm.dataEditUser,
              stateCarrouselDefault: _vm.stateCarrouselDefault,
            },
            on: { closePopUp: _vm.closeAddPopUpUser, submit: _vm.editUser },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }